// Spin the Bottle / Truth or Dare — client registry entry (see ../registry.ts
// and docs/games-contract.md). Server rules: supabase/functions/games/bottle.ts.

import { RotateCw } from 'lucide-react';
import type { GameClientDef } from '../types';
import { MIN_PLAYERS, MAX_PLAYERS, PASS_LIMIT } from '../../../../supabase/functions/games/bottle.ts';
import { BOTTLE_CHAIRS, FOOTPRINT } from './bottleLayout';
import { BottleRugSet } from './BottleRugSet';
import { BottleTable3D } from './BottleTable3D';
import { BottleOverlay } from './BottleOverlay';
import { BottleVRPanel } from './BottleVR';

export const BOTTLE_RULES: GameClientDef['rules'] = [
  {
    title: 'The circle',
    lines: [
      `${MIN_PLAYERS}–${MAX_PLAYERS} players sit on the cushions around the rug. Friends can join or leave at any time.`,
      'Keep it friendly: everything is PG and in-world — no personal info, nothing anyone isn\'t comfortable with.',
    ],
  },
  {
    title: 'A turn',
    lines: [
      'The spinner spins the bottle (tap Spin, or in VR pinch the bottle and flick it). It never lands on the spinner.',
      'Truth or Dare mode: whoever it points at chooses Truth or Dare. Spin the Bottle mode: the spinner chooses for them.',
      'A card is drawn for everyone to see. Do it, then tap Done — or tap Pass (you get ' + PASS_LIMIT + ' passes per game).',
      'The player the bottle chose spins next.',
    ],
  },
  {
    title: 'Points',
    lines: [
      'Dare done: +2. Truth done: +1. Pass: 0.',
      'Everyone else can clap once per turn: each clap is +1 for the player on the spot.',
      'Most points when the game ends wins.',
    ],
  },
  {
    title: 'Keeping it fun',
    lines: [
      'Not OK with a card? Anyone can vote Skip card — if most of the circle agrees, a new card is drawn.',
      'Pick a number of rounds in the lobby, or play Endless and vote to end when you\'re done (a majority ends it, and the scores still count).',
      'The world owner can remove a player from the game.',
      'Mild cards are gentle; Silly adds goofier ones.',
    ],
  },
];

export const bottleClient: GameClientDef = {
  kind: 'bottle',
  label: 'Spin the Bottle',
  blurb: 'Truth or Dare party game for 3–12 — spin, pick, laugh. Family-friendly cards.',
  icon: RotateCw,
  glyph: '?',
  category: 'party',
  minPlayers: MIN_PLAYERS,
  maxPlayers: MAX_PLAYERS,
  bots: false,
  host: 'none',
  joinMidGame: true,
  seatNames: BOTTLE_CHAIRS.map((_, i) => `Cushion ${i + 1}`),
  ranking: 'points',
  chairs: BOTTLE_CHAIRS,
  footprint: { w: FOOTPRINT, d: FOOTPRINT },
  nearRadius: 3.6,
  Furniture: BottleRugSet,
  Table3D: BottleTable3D,
  Overlay: BottleOverlay,
  VRPanel: BottleVRPanel,
  rules: BOTTLE_RULES,
};
